import {
  tablesDB,
  DATABASE_ID,
  PROMOTIONS_TABLE_ID,
  STORE_APPLICATIONS_TABLE_ID,
  ID,
  Query,
  storage,
  getFileViewUrl,
} from '../lib/appwrite';

const BUCKET_ID = process.env.REACT_APP_APPWRITE_STORAGE_BUCKET_ID;

// ── Promotions ──────────────────────────────────────────────

export async function listPromotions() {
  const res = await tablesDB.listRows(DATABASE_ID, PROMOTIONS_TABLE_ID);
  return res?.rows || res?.documents || [];
}

export async function getPromotion(promotionId) {
  return tablesDB.getRow(DATABASE_ID, PROMOTIONS_TABLE_ID, promotionId);
}

export async function createPromotion(data) {
  const id = ID.unique();
  return tablesDB.createRow(DATABASE_ID, PROMOTIONS_TABLE_ID, id, {
    ...data,
    status: data.status || 'active',
    createdAt: new Date().toISOString(),
  });
}

export async function updatePromotion(promotionId, data) {
  return tablesDB.updateRow(DATABASE_ID, PROMOTIONS_TABLE_ID, promotionId, data);
}

export async function deletePromotion(promotionId) {
  return tablesDB.deleteRow(DATABASE_ID, PROMOTIONS_TABLE_ID, promotionId);
}

export async function togglePromotionStatus(promotionId, currentStatus) {
  const next = currentStatus === 'active' ? 'inactive' : 'active';
  return tablesDB.updateRow(DATABASE_ID, PROMOTIONS_TABLE_ID, promotionId, { status: next });
}

// ── Store applications ──────────────────────────────────────

export async function listStoreApplications() {
  const res = await tablesDB.listRows(DATABASE_ID, STORE_APPLICATIONS_TABLE_ID);
  return res?.rows || res?.documents || [];
}

export async function approveApplication(applicationId, storeData) {
  await tablesDB.updateRow(DATABASE_ID, STORE_APPLICATIONS_TABLE_ID, applicationId, {
    status: 'approved',
    reviewedAt: new Date().toISOString(),
  });
  // Auto-create a promotion entry for the approved store
  const id = ID.unique();
  return tablesDB.createRow(DATABASE_ID, PROMOTIONS_TABLE_ID, id, {
    type: 'store_showcase',
    storeId: storeData.storeId,
    storeName: storeData.storeName,
    description: storeData.message || '',
    color: '#065F46',
    discount: 0,
    status: 'active',
    sourceApplicationId: applicationId,
    createdAt: new Date().toISOString(),
  });
}

export async function rejectApplication(applicationId, reason = '') {
  return tablesDB.updateRow(DATABASE_ID, STORE_APPLICATIONS_TABLE_ID, applicationId, {
    status: 'rejected',
    rejectionReason: reason,
    reviewedAt: new Date().toISOString(),
  });
}

// ── Image upload ────────────────────────────────────────────

export async function uploadPromotionImage(file) {
  if (!BUCKET_ID) throw new Error('Storage bucket not configured');
  const uploaded = await storage.createFile(BUCKET_ID, ID.unique(), file);
  return uploaded.$id;
}

export function getPromotionImageUrl(imageId) {
  if (!imageId) return null;
  return getFileViewUrl(imageId);
}

export async function deletePromotionImage(imageId) {
  if (!imageId || !BUCKET_ID) return;
  try {
    await storage.deleteFile(BUCKET_ID, imageId);
  } catch { /* ignore if already deleted */ }
}
